import { MaterialReactTable } from "material-react-table";
import { getImageUrl } from "utils/imageHelper";


export default function EventCategoryTable({
  data = [],
  loading,
  onEdit,
  onDelete,
}) {
  const columns = [
    {
      accessorKey: "title",
      header: "Category Name",
    },
    {
          accessorKey: "eventCategoryImage",
          header: "Image",
          Cell: ({ cell }) => {
            const value = cell.getValue();
            return value ? (
              <div className="flex">
                <img
                  src={getImageUrl(value)}
                  alt="Category"
                  className="h-12 w-12 rounded border object-cover"
                />
              </div>
            ) : (
              <span className="text-gray-400">-</span>
            );
          }
    },
    {
      header: "Actions",
      Cell: ({ row }) => (
        <div className="flex gap-2">

          <button
            onClick={() => onEdit(row.original)}
            className="rounded bg-yellow-100 px-3 py-1 text-xs text-yellow-700"
          >
            Edit
          </button>

          <button
            onClick={() => {
              if (
                window.confirm(
                  `Delete category "${row.original.title}"?`
                )
              ) {
                onDelete(row.original);
              }
            }}
            className="rounded bg-red-100 px-3 py-1 text-xs text-red-700"
          >
            Delete
          </button>
        </div>
      ),
    },
  ];

  return (
    <MaterialReactTable
      columns={columns}
      data={data}
      state={{ isLoading: loading }}
      enableExpanding
      getSubRows={(row) => row.children}
      muiTableBodyRowProps={{ hover: true }}
      enableGlobalFilter={false}
    />
  );
}
